import DataSeriesModel from '../models/DataSeriesModel';
import BaseStore from './BaseStore';
import { computed } from 'mobx';

class DataSeriesStore extends BaseStore {
  stationStore;

  constructor(transportLayer, parameterUnitStore) {
    super(DataSeriesModel, transportLayer);
    this.parameterUnitStore = parameterUnitStore;
  }

  flattenTableData(dataArray) {
    const arr = [];
    console.log('dataArray', dataArray);

    dataArray.forEach(dataSeries => {
      arr.push({
        type: 'DATA_SERIES',
        level: 1,
        key: dataSeries.id,
        slug: 'parameter-type',
        childSlug: `parameter-type/${dataSeries.id}/parameter`,

        id: dataSeries.id,
        name: dataSeries.name,
        unit: dataSeries.parameter_unit.name,
        qc: null,
      });
      dataSeries.qc_rules.forEach(qcRule => {
        arr.push({
          type: 'QC_RULE',
          level: 2,
          key: `${dataSeries.id}.${qcRule.id}`,
          slug: `qcRule-type/${dataSeries.id}/qcRule`,

          id: qcRule.id,
          name: qcRule.type.name,
          unit: null,
          qc: null,
        });
      });
    });

    console.log('arr', arr);

    return arr;
  }

  @computed get tableData() {
    console.log('this.items', this.items);
    return this.flattenTableData(this.items);
  }

  updateQCRules(dataSeriesId, qcRuleIds) {
    if (!dataSeriesId) { throw new Error('Update failure. Invalid id.'); }
    return this.transportLayer.updateQCRules(dataSeriesId, qcRuleIds);
  }


}

export default DataSeriesStore;



// WEBPACK FOOTER //
// ./src/stores/DataSeriesStore.js